/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Delete_Account_HeadingInputs */

const en_delete_account_heading = /** @type {(inputs: Delete_Account_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete your Brave Premium account`)
};

const id_delete_account_heading = /** @type {(inputs: Delete_Account_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menghapus akun Brave Premium`)
};

const ms_delete_account_heading = /** @type {(inputs: Delete_Account_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Padamkan akaun Brave Premium anda`)
};

const ca_delete_account_heading = /** @type {(inputs: Delete_Account_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eliminar el teu compte de Brave Premium`)
};

const cs_delete_account_heading = /** @type {(inputs: Delete_Account_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Odstraňte svůj účet Brave Premium`)
};

const da_delete_account_heading = /** @type {(inputs: Delete_Account_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Slet din Brave Premium-konto`)
};

const de_delete_account_heading = /** @type {(inputs: Delete_Account_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dein Brave Premium-Konto löschen`)
};

const et_delete_account_heading = /** @type {(inputs: Delete_Account_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kustutage oma tasulise Brave'i konto`)
};

const es_delete_account_heading = /** @type {(inputs: Delete_Account_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elimina tu cuenta de Brave Premium`)
};

const fr_delete_account_heading = /** @type {(inputs: Delete_Account_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suppression de votre compte Brave Premium`)
};

const hr_delete_account_heading = /** @type {(inputs: Delete_Account_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Izbrišite svoj račun Brave Premium`)
};

const it_delete_account_heading = /** @type {(inputs: Delete_Account_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elimina il tuo account Brave Premium`)
};

const lv_delete_account_heading = /** @type {(inputs: Delete_Account_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave Premium konta dzēšana`)
};

const lt_delete_account_heading = /** @type {(inputs: Delete_Account_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`„Brave Premium“ paskyros ištrynimas`)
};

const hu_delete_account_heading = /** @type {(inputs: Delete_Account_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Törölje Brave Premium fiókját`)
};

const nl_delete_account_heading = /** @type {(inputs: Delete_Account_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Je Brave Premium-account verwijderen`)
};

const nb_delete_account_heading = /** @type {(inputs: Delete_Account_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Slette Brave Premium-kontoen din`)
};

const pl_delete_account_heading = /** @type {(inputs: Delete_Account_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usuń swoje konto Brave Premium`)
};

const pt_delete_account_heading = /** @type {(inputs: Delete_Account_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exclua sua conta Brave Premium`)
};

const ro_delete_account_heading = /** @type {(inputs: Delete_Account_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Șterge contul tău Brave Premium`)
};

const sk_delete_account_heading = /** @type {(inputs: Delete_Account_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Odstránenie účtu Brave Premium`)
};

const sl_delete_account_heading = /** @type {(inputs: Delete_Account_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brisanje računa Brave Premium`)
};

const fi_delete_account_heading = /** @type {(inputs: Delete_Account_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Poista Brave Premium -tilisi`)
};

const sv_delete_account_heading = /** @type {(inputs: Delete_Account_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ta bort ditt Brave Premium-konto`)
};

const vi_delete_account_heading = /** @type {(inputs: Delete_Account_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Xóa tài khoản Brave Premium của bạn`)
};

const tr_delete_account_heading = /** @type {(inputs: Delete_Account_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave Premium hesabınızı silin`)
};

const el_delete_account_heading = /** @type {(inputs: Delete_Account_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Διαγράψτε τον λογαριασμό σας Brave Premium`)
};

const bg_delete_account_heading = /** @type {(inputs: Delete_Account_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Изтриване на твоя акаунт в Brave Premium`)
};

const ru_delete_account_heading = /** @type {(inputs: Delete_Account_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Удалить Brave Premium аккаунт`)
};

const sr_delete_account_heading = /** @type {(inputs: Delete_Account_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Брисање Brave Premium налога`)
};

const uk_delete_account_heading = /** @type {(inputs: Delete_Account_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Видаліть свій преміум-акаунт Brave`)
};

const ka_delete_account_heading = /** @type {(inputs: Delete_Account_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`წაშალეთ თქვენი Brave Premium-ის ანგარიში`)
};

const hi_delete_account_heading = /** @type {(inputs: Delete_Account_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अपना ब्रेव प्रीमियम अकाउंट डिलीट करें`)
};

const th_delete_account_heading = /** @type {(inputs: Delete_Account_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ลบบัญชี Brave Premium ของคุณ`)
};

const ko_delete_account_heading = /** @type {(inputs: Delete_Account_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave 프리미엄 계정 삭제`)
};

const zh_delete_account_heading = /** @type {(inputs: Delete_Account_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`删除您的 Brave Premium 账户`)
};

const zh_tw_delete_account_heading = /** @type {(inputs: Delete_Account_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`刪除您的 Brave 高級版帳戶`)
};

const ja_delete_account_heading = /** @type {(inputs: Delete_Account_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave Premiumアカウントの削除`)
};

/**
* | output |
* | --- |
* | "Delete your Brave Premium account" |
*
* @param {Delete_Account_HeadingInputs} inputs
* @param {{ locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }} options
* @returns {LocalizedString}
*/
export const delete_account_heading = /** @type {((inputs?: Delete_Account_HeadingInputs, options?: { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Delete_Account_HeadingInputs, { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_delete_account_heading(inputs)
	if (locale === "ms") return ms_delete_account_heading(inputs)
	if (locale === "ca") return ca_delete_account_heading(inputs)
	if (locale === "cs") return cs_delete_account_heading(inputs)
	if (locale === "da") return da_delete_account_heading(inputs)
	if (locale === "de") return de_delete_account_heading(inputs)
	if (locale === "et") return et_delete_account_heading(inputs)
	if (locale === "es") return es_delete_account_heading(inputs)
	if (locale === "fr") return fr_delete_account_heading(inputs)
	if (locale === "hr") return hr_delete_account_heading(inputs)
	if (locale === "it") return it_delete_account_heading(inputs)
	if (locale === "lv") return lv_delete_account_heading(inputs)
	if (locale === "lt") return lt_delete_account_heading(inputs)
	if (locale === "hu") return hu_delete_account_heading(inputs)
	if (locale === "nl") return nl_delete_account_heading(inputs)
	if (locale === "nb") return nb_delete_account_heading(inputs)
	if (locale === "pl") return pl_delete_account_heading(inputs)
	if (locale === "pt") return pt_delete_account_heading(inputs)
	if (locale === "ro") return ro_delete_account_heading(inputs)
	if (locale === "sk") return sk_delete_account_heading(inputs)
	if (locale === "sl") return sl_delete_account_heading(inputs)
	if (locale === "fi") return fi_delete_account_heading(inputs)
	if (locale === "sv") return sv_delete_account_heading(inputs)
	if (locale === "vi") return vi_delete_account_heading(inputs)
	if (locale === "tr") return tr_delete_account_heading(inputs)
	if (locale === "el") return el_delete_account_heading(inputs)
	if (locale === "bg") return bg_delete_account_heading(inputs)
	if (locale === "ru") return ru_delete_account_heading(inputs)
	if (locale === "sr") return sr_delete_account_heading(inputs)
	if (locale === "uk") return uk_delete_account_heading(inputs)
	if (locale === "ka") return ka_delete_account_heading(inputs)
	if (locale === "hi") return hi_delete_account_heading(inputs)
	if (locale === "th") return th_delete_account_heading(inputs)
	if (locale === "ko") return ko_delete_account_heading(inputs)
	if (locale === "zh") return zh_delete_account_heading(inputs)
	if (locale === "zh-tw") return zh_tw_delete_account_heading(inputs)
	if (locale === "ja") return ja_delete_account_heading(inputs)
	return en_delete_account_heading(inputs)
});